import { Box, Dialog } from "@mui/material"
import React, { useContext, useEffect, useState } from "react"
import CloseButton from "../../../components/CloseButton"
import CommonTypo from "../../../components/CommonTypo"
import { Input } from "../../../components/inputGroup";
import NewButton from "../../../components/NewButton";
import HTMLTooltip from "../../../components/HTMLTooltip";
import typography, { pxToRem } from "../../../theme/typography";
import SelectionDialogue from "./selectionDialogue";
import { integrationsService } from "../../../services/integrations";
import SuccessDialogue from "./successDialogue";
import { INTEGRATINOS_TYPES } from "../integrationsConstants";
import { IntegrationContext } from "../../../context/userIntegrations";
import { setConnectionName, setIsConnecting, setShowModal } from "../../../store/actions/integrationActions";
import ConnectingDialogue from "./connectingDialogue";
import ConnectingIcon from "../../../assets/images/icon/integration/connecting";
import { TrackingContext } from "../../../context/userTracking";
import { UserTypeContext } from "../../../context/userStatus";
import { trackingService } from "../../../services/tracking";
import { addCategoryExpandAction, addCategoryJourneyAction, addJourneyAction, addNotesAction, addNotesJourneyAction, isEmptyState } from "../../../store/actions/userTypeAction";
import moment from "moment";
import { setTrackingState } from "../../../store/actions/trackerAction";

const IntegrationDialogue = ({
    openModal,
    isMobile,
    modalType,
    onClose,
    outcomeState,
    setShowSnakbar,
    setSnakbarMsg,
    setMsgType,
    rescueResponse = {} as any,
    togglResponse = {} as any,
    garminResponse = {},
    whoopResponse = {},
    gFitResponse = {},
    getRescueTime,
    getTogglTime,
    getOURATime,
    getGarminTime,
    getWhoopTime,
    getGFitTime,
    setModalType,
    isEditMode,
    setEditMode,
    ouraResponse,
    integrationState,
    openSelection,
    setOpenSelection,
    integrationDispatch,
    fromTutorials = false
}) => {
    const { state: ITrackerState, dispatch: trackingDispatch } =
        useContext(TrackingContext);
    const { state: IUserTypeState, dispatch: userTypeDispatch } =
        useContext(UserTypeContext);
    const {
        startDate,
        endDate,
        calendar,
        today,
        isFirst,
        isExpandable,
        isLastAlreadyLoaded,
    } = ITrackerState;
    const getPeronsltrackData = async (bodyData) => {
        let data = await trackingService.getPersonalJourneyList(
            IUserTypeState.token,
            bodyData
        );
        if (data.data.length <= 0) {
            userTypeDispatch(isEmptyState(true));
        } else {
            userTypeDispatch(isEmptyState(false));
        }

        userTypeDispatch(addCategoryJourneyAction(data?.data));
        userTypeDispatch(addNotesJourneyAction(data?.data));
        const newAr = JSON.parse(localStorage.getItem("menuExpandableIds") || '[]')

        if (newAr && newAr.length) {
            userTypeDispatch(addCategoryExpandAction(newAr));
        } else {
            const newArr = [...IUserTypeState?.journeyCategoryExpandList];
            for (let index = 0; index < data?.data.length; index++) {
                const element = data?.data[index];
                newArr.push(element.categoryId);
            }
            // if (!IUserTypeState?.isPersonal) {
            newArr.push("outcome", "influence", "reflective");
            localStorage.setItem("menuExpandableIds", JSON.stringify(newArr))
            userTypeDispatch(addCategoryExpandAction(newArr));
        }
    };
    const callservice = async (showLoader = true) => {
        try {
            const bodyData = {
                from: moment(startDate).format("MM-DD-YYYY"),
                to: moment(endDate).format("MM-DD-YYYY"),
            };
            const personalDataLoaded =
                localStorage.getItem("personalDataLoaded") === "true";
            if (!personalDataLoaded && IUserTypeState.isPersonal) {
                trackingDispatch(
                    setTrackingState({
                        showLoader:
                            IUserTypeState.journeyCategoryList &&
                                IUserTypeState.journeyCategoryList.length
                                ? false
                                : true,
                    })
                );
            }
            trackingDispatch(
                setTrackingState({
                    showLoader: showLoader,
                })
            );
            let data = await trackingService.getJourneyList(
                IUserTypeState.token,
                bodyData
            );
            userTypeDispatch(addJourneyAction(data));
            userTypeDispatch(addNotesAction(data));

            //   const newAr = JSON.parse(localStorage.getItem("menuExpandableIds") || '[]')
            // console.log("newAr", newAr);
            //   if(newAr && newAr.length) {
            //     userTypeDispatch(addCategoryExpandAction(newAr));
            //   } else {
            //     const newArr = [
            //       ...IUserTypeState?.journeyCategoryExpandList,
            //       "outcome",
            //       "influence",
            //       "reflective",
            //     ];
            //     userTypeDispatch(addCategoryExpandAction(newArr));
            //   }
            trackingDispatch(
                setTrackingState({
                    showLoader: false,
                })
            );
            // userTypeDispatch(pushCategoryJourneyAction([{
            //     categoryId: "outcome", expanded: true
            // },
            // ]));
            // userTypeDispatch(pushCategoryJourneyAction([
            //     {
            //         categoryId: "influence", expanded: true
            //     },
            // ]));
            // userTypeDispatch(pushCategoryJourneyAction([
            //     {
            //         categoryId: "reflective", expanded: true
            //     }]));

            if (!personalDataLoaded) {
                await getPeronsltrackData(bodyData);
            }

            localStorage.removeItem("personalDataLoaded");
            setTimeout(() => {
                // currentDateRef && currentDateRef.current && currentDateRef.current.scrollIntoView()
            }, 500);
        } catch (error) {
            trackingDispatch(
                setTrackingState({
                    showLoader: false,
                })
            );
        }
    };
    const [apiToken, setAPIToken] = useState("")
    const [rescueTimePercents, setRescueTimePercents] = useState([])
    const [tooglData, setTogglData] = useState([])
    const [ouraData, setOuraData] = useState([])
    const [ouraDataConversions, setOuraDataConversions] = useState([])
    const [garminData, setGarminData] = useState([])
    const [whoopData, setWhoopData] = useState([])
    const [whoopDataConversions, setWhoopDataConversions] = useState([])
    const [gFitData, setGFitData] = useState([])
    const [gFitDataConversions, setGFitDataConversions] = useState([])
    const [openTooltip, setOpenTooltip] = useState(false)
    const [isconnecting, setConnecting] = useState(false)
    const [openSelectionModal, setOpenSelectionModal] = useState(false)
    const [openSuccessModal, setOpenSuccessModal] = useState(false)
    const [openConnectingModal, setOpenConnectingModal] = useState(false)
    let paperStyles: any = {
        display: 'flex !important',
        padding: '16px 24px 32px !important',
        flexDirection: 'column !important',
        alignItems: 'flex-start !important',
        gap: '32px !important',
        minWidth: "579px",
        maxWidth: "max-content",
        borderRadius: "12px !important"
    }
    let paperStylesMobile: any = {
        display: 'flex !important',
        padding: '20px',
        flexDirection: 'column !important',
        alignItems: 'flex-start !important',
        gap: '16px !important',
        minWidth: "90%",
        borderRadius: "20px"
    }
    useEffect(() => {


        if (isEditMode && modalType === INTEGRATINOS_TYPES.RESCUE_TIME) {
            integrationsService.getDataRescueData({
                dataType: "hours"
            }, outcomeState.token).then(data => {
                setRescueTimePercents(data.data)
                setOpenSelectionModal(true)
            }).catch(err => {
                integrationsService.updateKeyRescueTime({
                    apiKey: null
                }, outcomeState.token)
                setShowSnakbar(true)
                setSnakbarMsg("We couln't fetch data, check API token")
                setMsgType("error")
            })
            setOpenSelectionModal(true)
        }
        if (isEditMode && modalType === INTEGRATINOS_TYPES.OURA) {
            integrationsService.getDataOURA({
                dataType: "hours"
            }, outcomeState.token).then(data => {
                setOuraData(data.mappedData)
                setOuraDataConversions(data.nameConventions)
                setOpenSelectionModal(true)
            }).catch(err => {
                integrationsService.updateKeyOURA({
                    apiKey: null
                }, outcomeState.token)
                setShowSnakbar(true)
                setSnakbarMsg("We couln't fetch data, check API token")
                setMsgType("error")
            })
            setOpenSelectionModal(true)
        }
        if (isEditMode && modalType === INTEGRATINOS_TYPES.TOGGL) {
            integrationsService.getDataToggl({}, outcomeState.token).then(data => {
                console.log("data", data);

                setTogglData(data.data)
                setOpenSelectionModal(true)
            }).catch(err => {
                integrationsService.updateKeyToogl({
                    apiKey: null
                }, outcomeState.token)
                setShowSnakbar(true)
                setSnakbarMsg("We couln't fetch data, check API token")
                setMsgType("error")
            })
            setOpenSelectionModal(true)
        }
        if (openSelection && !isEditMode && modalType === INTEGRATINOS_TYPES.GARMIN) {
            integrationsService.getDataGarmin({
            }, outcomeState.token).then(data => {
                setGarminData(data.allKeys)
                setOpenSelectionModal(true)
                setOpenSelection(false)
            }).catch(err => {
                setShowSnakbar(true)
                setSnakbarMsg("We couln't fetch data, check API token")
                setMsgType("error")
            })
            setOpenSelectionModal(true)
        }
        if (!openSelection && isEditMode && modalType === INTEGRATINOS_TYPES.GARMIN) {
            integrationsService.getDataGarmin({}, outcomeState.token).then(data => {
                setGarminData(data.allKeys)
                setOpenSelectionModal(true)
            }).catch(err => {
                setShowSnakbar(true)
                setSnakbarMsg("We couln't fetch data, check API token")
                setMsgType("error")
            })
            setOpenSelectionModal(true)
        }
        if (openSelection && !isEditMode && modalType === INTEGRATINOS_TYPES.WHOOP) {
            integrationsService.getDataWhoop({
            }, outcomeState.token).then(data => {
                setWhoopData(data.allKeys)
                setWhoopDataConversions(data.nameConventions)
                setOpenSelectionModal(true)
                setOpenSelection(false)
            }).catch(err => {
                setShowSnakbar(true)
                setSnakbarMsg("We couln't fetch data, check API token")
                setMsgType("error")
            })
            setOpenSelectionModal(true)
        }
        if (!openSelection && isEditMode && modalType === INTEGRATINOS_TYPES.WHOOP) {
            integrationsService.getDataWhoop({}, outcomeState.token).then(data => {
                setWhoopData(data.allKeys)
                setWhoopDataConversions(data.nameConventions)
                setOpenSelectionModal(true)
            }).catch(err => {
                setShowSnakbar(true)
                setSnakbarMsg("We couln't fetch data, check API token")
                setMsgType("error")
            })
            setOpenSelectionModal(true)
        }
        if (openSelection && !isEditMode && modalType === INTEGRATINOS_TYPES.GOOGLE_FIT) {
            integrationsService.getDataGFit({
            }, outcomeState.token).then(data => {
                setGFitData(data.allKeys)
                setGFitDataConversions(data.nameConventions)
                setOpenSelectionModal(true)
                setOpenSelection(false)
            }).catch(err => {
                setShowSnakbar(true)
                setSnakbarMsg("We couln't fetch data, check API token")
                setMsgType("error")
            })
            setOpenSelectionModal(true)
        }
        if (!openSelection && isEditMode && modalType === INTEGRATINOS_TYPES.GOOGLE_FIT) {
            integrationsService.getDataGFit({}, outcomeState.token).then(data => {
                setGFitData(data.allKeys)
                setGFitDataConversions(data.nameConventions)
                setOpenSelectionModal(true)
            }).catch(err => {
                setShowSnakbar(true)
                setSnakbarMsg("We couln't fetch data, check API token")
                setMsgType("error")
            })
            setOpenSelectionModal(true)
        }
    }, [isEditMode, modalType, openSelection, outcomeState.token, setMsgType, setShowSnakbar, setSnakbarMsg])
    useEffect(() => {
        if (rescueResponse && rescueResponse.apiKey && modalType === INTEGRATINOS_TYPES.RESCUE_TIME) {
            setAPIToken(rescueResponse.apiKey)
        }
        if (togglResponse && togglResponse.apiKey && modalType === INTEGRATINOS_TYPES.TOGGL) {
            setAPIToken(togglResponse.apiKey)
        }

        return () => setAPIToken(null)
    }, [rescueResponse, togglResponse, modalType])
    const renderIcon = (icon, onClick = () => { }) => (
        <div onClick={onClick}>
            {icon}
        </div>
    );
    const closemodal = () => {
        setAPIToken("")
        setOpenTooltip(false)
        onClose()
    }
    const connectToIntegration = () => {
        setConnecting(true)
        if (modalType === INTEGRATINOS_TYPES.RESCUE_TIME) {
            integrationsService.updateKeyRescueTime({
                apiKey: apiToken
            }, outcomeState.token).then(data => {
                integrationsService.getDataRescueData({
                    dataType: "hours"
                }, outcomeState.token).then(data => {
                    setRescueTimePercents(data.data)
                    setOpenSelectionModal(true)
                    setConnecting(false)
                }).catch(err => {
                    integrationsService.updateKeyRescueTime({
                        apiKey: null
                    }, outcomeState.token)
                    setShowSnakbar(true)
                    setConnecting(false)
                    setSnakbarMsg("We couln't fetch data, check API token")
                    setMsgType("error")
                })
            }).catch(err => {
                setShowSnakbar(true)
                setSnakbarMsg("We couln't fetch data, check API token")
                setMsgType("error")
                setConnecting(false)
                console.log("err", err)
            })
        }
        if (modalType === INTEGRATINOS_TYPES.TOGGL) {
            integrationsService.updateKeyToogl({
                apiKey: apiToken
            }, outcomeState.token).then(data => {
                integrationsService.getDataToggl({
                }, outcomeState.token).then(data => {
                    console.log("data", data);
                    setTogglData(data.data)
                    // setRescueTimePercents(data.data)
                    setOpenSelectionModal(true)
                    setConnecting(false)
                }).catch(err => {
                    integrationsService.updateKeyToogl({
                        apiKey: null
                    }, outcomeState.token)
                    setConnecting(false)
                    setShowSnakbar(true)
                    setSnakbarMsg("We couln't fetch data, check API token")
                    setMsgType("error")
                })
            }).catch(err => {
                setConnecting(false)
                setShowSnakbar(true)
                setSnakbarMsg("We couln't fetch data, check API token")
                setMsgType("error")
                console.log("err", err)
            })
        }
        if (modalType === INTEGRATINOS_TYPES.OURA) {
            integrationsService.updateKeyOURA({
                apiKey: apiToken
            }, outcomeState.token).then(data => {
                integrationsService.getDataOURA({
                    dataType: "hours"
                }, outcomeState.token).then(data => {
                    console.log("getDataOURA data", data);
                    setOuraData(data.mappedData)
                    setOuraDataConversions(data.nameConventions)
                    setConnecting(false)
                    // onClose()
                    // setRescueTimePercents(data.data)
                    setOpenSelectionModal(true)
                }).catch(err => {
                    integrationsService.updateKeyOURA({
                        apiKey: null
                    }, outcomeState.token)
                    setConnecting(false)
                    setShowSnakbar(true)
                    setSnakbarMsg("We couln't fetch data, check API token")
                    setMsgType("error")
                })
            }).catch(err => {
                setConnecting(false)
                setShowSnakbar(true)
                setSnakbarMsg("We couln't fetch data, check API token")
                setMsgType("error")
                console.log("err", err)
            })
        }
    }
    const updateRescueTime = (type, seelctedKeys, closemodal) => {
        setOpenConnectingModal(true)
        onClose()
        closemodal()
        integrationDispatch(setConnectionName(modalType))
        integrationDispatch(setIsConnecting(true))
        integrationsService.updateRescueData({
            dataType: type,
            keysArray: seelctedKeys
        }, outcomeState.token).then(data => {
            getRescueTime()
            setOpenTooltip(false)
            onClose()
            setOpenConnectingModal(false)
            integrationDispatch(setIsConnecting(false))
            integrationDispatch(setShowModal(true))
            setOpenSuccessModal(true)
            if(fromTutorials) callservice()
        }).catch(err => {
            console.log("err", err)
        })
    }

    const updateToggl = (seelctedKeys, closemodal) => {
        setOpenConnectingModal(true)
        onClose()
        closemodal()
        integrationDispatch(setConnectionName(modalType))
        integrationDispatch(setIsConnecting(true))
        integrationsService.updateTogglData({
            keysArray: seelctedKeys
        }, outcomeState.token).then(data => {
            getTogglTime()
            setOpenTooltip(false)
            setOpenConnectingModal(false)
            integrationDispatch(setIsConnecting(false))
            integrationDispatch(setShowModal(true))
            onClose()
            setOpenSuccessModal(true)
            if(fromTutorials) callservice()
        }).catch(err => {
            console.log("err", err)
        })
    }

    const updateOura = (seelctedKeys, closemodal) => {
        setOpenConnectingModal(true)
        onClose()
        closemodal()
        integrationDispatch(setConnectionName(modalType))
        integrationDispatch(setIsConnecting(true))
        integrationsService.updateOURAData({
            keysArray: seelctedKeys
        }, outcomeState.token).then(data => {
            getOURATime()
            setOpenTooltip(false)
            setOpenConnectingModal(false)
            integrationDispatch(setIsConnecting(false))
            integrationDispatch(setShowModal(true))
            onClose()
            setOpenSuccessModal(true)
            if(fromTutorials) callservice()
        }).catch(err => {
            console.log("err", err)
        })
    }
    const updateGarmin = (seelctedKeys, closemodal) => {
        setOpenConnectingModal(true)
        onClose()
        closemodal()
        integrationDispatch(setConnectionName(modalType))
        integrationDispatch(setIsConnecting(true))
        integrationsService.updateGarminData({
            keysArray: seelctedKeys
        }, outcomeState.token).then(data => {
            getGarminTime()
            setOpenTooltip(false)
            setOpenConnectingModal(false)
            integrationDispatch(setIsConnecting(false))
            integrationDispatch(setShowModal(true))
            onClose()
            setOpenSuccessModal(true)
            if(fromTutorials) callservice()
        }).catch(err => {
            console.log("err", err)
        })
    }
    const updateWhoop = (seelctedKeys, closemodal) => {
        setOpenConnectingModal(true)
        onClose()
        closemodal()
        integrationDispatch(setConnectionName(modalType))
        integrationDispatch(setIsConnecting(true))
        integrationsService.updateWhoopData({
            keysArray: seelctedKeys
        }, outcomeState.token).then(data => {
            getWhoopTime()
            setOpenTooltip(false)
            setOpenConnectingModal(false)
            integrationDispatch(setIsConnecting(false))
            integrationDispatch(setShowModal(true))
            onClose()
            setOpenSuccessModal(true)
            if(fromTutorials) callservice()
        }).catch(err => {
            console.log("err", err)
        })
    }
    const updateGFit = (seelctedKeys, closemodal) => {
        setOpenConnectingModal(true)
        onClose()
        closemodal()
        integrationDispatch(setConnectionName(modalType))
        integrationDispatch(setIsConnecting(true))
        integrationsService.updateGFitData({
            keysArray: seelctedKeys
        }, outcomeState.token).then(data => {
            getGFitTime()
            setOpenTooltip(false)
            setOpenConnectingModal(false)
            integrationDispatch(setIsConnecting(false))
            integrationDispatch(setShowModal(true))
            onClose()
            setOpenSuccessModal(true)
            if(fromTutorials) callservice()
        }).catch(err => {
            console.log("err", err)
        })
    }
    const getPlaceHolder = () => {
        let st = 'Insert your'
        if (modalType === INTEGRATINOS_TYPES.TOGGL) st += ` Toggl`
        if (modalType === INTEGRATINOS_TYPES.RESCUE_TIME) st += ` RescueTime`
        if (modalType === INTEGRATINOS_TYPES.OURA) st += ` Oura`
        return st + ' API token'
    }

    return <>
        <Dialog
            onClose={closemodal}
            open={openModal}
            className={!isMobile && "dialogWrapper"}
            disableEscapeKeyDown
            sx={{
                zIndex: 1001,
                "& .MuiDialog-paper": isMobile ? paperStylesMobile : paperStyles
            }}
        >
            <Box display={"flex"} flexBasis={1} alignSelf={"stretch"} alignItems={"center"} justifyContent={"flex-end"}>
                <CloseButton onClick={closemodal} boxStyle={{
                    display: "flex"
                }} />
            </Box>
            <Box display={"flex"} flexBasis={1} alignSelf={"stretch"} alignItems={"center"} justifyContent={"flex-start"}>
                <CommonTypo size={24} lineHeight={28.8} fontWeight={700} color="var(--color-text-primary)">Token</CommonTypo>
            </Box>
            <Box display={"flex"} flexBasis={1} alignSelf={"stretch"} flexDirection={"column"} gap={"16px"}>
                <Box display={"flex"} flexBasis={1} alignSelf={"stretch"} alignItems={"center"} justifyContent={"space-between"} gap={"16px"}>
                    <CommonTypo size={16} lineHeight={19.2} fontWeight={600} color="var(--color-text-primary)">API Token</CommonTypo>
                    <HTMLTooltip
                        customIcon={renderIcon(<Box display={"flex"} alignItems={"center"} gap={"4px"}>
                            <CommonTypo size={12} lineHeight={14.4} fontWeight={400} color="var(--color-text-secondary)">Where to find token?</CommonTypo>
                            <CommonTypo size={12} lineHeight={14.4} fontWeight={400} color="var(--color-text-primary)">
                                <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M9.5 11.75C9.5 11.9478 9.44135 12.1411 9.33147 12.3056C9.22159 12.47 9.06541 12.5982 8.88269 12.6739C8.69996 12.7496 8.49889 12.7694 8.30491 12.7308C8.11093 12.6922 7.93275 12.597 7.7929 12.4571C7.65304 12.3173 7.5578 12.1391 7.51922 11.9451C7.48063 11.7511 7.50044 11.55 7.57612 11.3673C7.65181 11.1846 7.77998 11.0284 7.94443 10.9185C8.10888 10.8086 8.30222 10.75 8.5 10.75C8.76522 10.75 9.01957 10.8554 9.20711 11.0429C9.39465 11.2304 9.5 11.4848 9.5 11.75ZM15.25 8.5C15.25 9.83502 14.8541 11.1401 14.1124 12.2501C13.3707 13.3601 12.3165 14.2253 11.0831 14.7362C9.84971 15.2471 8.49252 15.3808 7.18314 15.1203C5.87377 14.8598 4.67104 14.217 3.72703 13.273C2.78303 12.329 2.14015 11.1262 1.8797 9.81686C1.61925 8.50749 1.75292 7.15029 2.26382 5.91689C2.77471 4.68349 3.63987 3.62928 4.7499 2.88758C5.85994 2.14588 7.16498 1.75 8.5 1.75C10.2896 1.75199 12.0053 2.46378 13.2708 3.72922C14.5362 4.99466 15.248 6.7104 15.25 8.5ZM13.75 8.5C13.75 7.46165 13.4421 6.44661 12.8652 5.58326C12.2883 4.7199 11.4684 4.04699 10.5091 3.64963C9.54978 3.25227 8.49418 3.1483 7.47578 3.35088C6.45738 3.55345 5.52192 4.05346 4.78769 4.78769C4.05347 5.52191 3.55345 6.45738 3.35088 7.47578C3.14831 8.49418 3.25228 9.54978 3.64964 10.5091C4.047 11.4684 4.7199 12.2883 5.58326 12.8652C6.44662 13.4421 7.46165 13.75 8.5 13.75C9.89193 13.7485 11.2264 13.1949 12.2107 12.2107C13.1949 11.2264 13.7485 9.89193 13.75 8.5ZM8.5 4.5C6.98375 4.5 5.75 5.62125 5.75 7V7.25C5.75 7.44891 5.82902 7.63968 5.96967 7.78033C6.11032 7.92098 6.30109 8 6.5 8C6.69892 8 6.88968 7.92098 7.03033 7.78033C7.17099 7.63968 7.25 7.44891 7.25 7.25V7C7.25 6.44875 7.8125 6 8.5 6C9.1875 6 9.75 6.44875 9.75 7C9.75 7.55125 9.1875 8 8.5 8C8.30109 8 8.11032 8.07902 7.96967 8.21967C7.82902 8.36032 7.75 8.55109 7.75 8.75V9.25C7.74956 9.4353 7.81772 9.6142 7.94135 9.75222C8.06498 9.89024 8.23533 9.97761 8.41956 9.99748C8.60378 10.0174 8.78885 9.96833 8.93907 9.85985C9.08929 9.75138 9.19404 9.59113 9.23313 9.41C10.3944 9.1175 11.25 8.14813 11.25 7C11.25 5.62125 10.0163 4.5 8.5 4.5Z" fill="#656565" />
                                </svg>
                            </CommonTypo>
                        </Box>, () => setOpenTooltip(!openTooltip))}
                        title={modalType === INTEGRATINOS_TYPES.RESCUE_TIME ?
                            <>You can set up an API key by going to the <a href="https://www.rescuetime.com/anapi/manage" target="_blank" rel="noreferrer">key management page </a> and creating a new key. That key must be included with each API request. You can revoke keys at any time.</>
                            : modalType === INTEGRATINOS_TYPES.TOGGL ? <>All users can locate their API key at the bottom of the <a href="https://track.toggl.com/profile" target="_blank" rel="noreferrer">Profile page. </a> </>
                                : modalType === INTEGRATINOS_TYPES.OURA ? <>Create token  <a href="https://cloud.ouraring.com/personal-access-tokens" target="_blank" rel="noreferrer">here </a> </>
                                    : ""}
                        fontProps={{
                            fontSize: `${pxToRem(12)} !important`,
                            lineHeight: `${pxToRem(14)} !important`,
                        }}
                        sx={{
                            zIndex: 2000,
                            pointerEvents: "all",
                            "& .MuiTooltip-tooltip": {
                                maxWidth: "300px",
                                zIndex: 2000
                            },
                        }}
                        placement="bottom-start"
                        customProps={{
                            open: openTooltip,
                            onClose: () => setOpenTooltip(!openTooltip),
                            disableFocusListener: true,
                            disableHoverListener: true,
                            disableTouchListener: true,
                        }}
                    />

                </Box>
                <Input placeholder={getPlaceHolder()} height={"53px"} extraSx={{
                    border: "1px solid var(--color-border)",
                    alignSelf: "stretch",
                    borderRadius: "12px",
                    marginBottom: "0px !important",
                    "& .MuiInputBase-root": {
                        borderRadius: "12px !important",
                        height: "53px",
                        "& .MuiInputBase-input": {
                            borderRadius: "12px",
                            height: "53px",
                            padding: "16px !important",
                            "&::placeholder": {
                                color: "var(--color-text-secondary)",
                                opacity: 1,
                                fontSize: "16px",
                                fontFamily: typography.fontFamily
                            }
                        },
                        "& .MuiOutlinedInput-notchedOutline": {
                            display: "none"
                        }
                    }
                }} value={apiToken}
                    onChange={(value) => setAPIToken(value)} />
            </Box>
            <Box display={"flex"} flex={1} width={"100%"} alignSelf={"stretch"} alignItems={"center"} gap={"8px"} >
                {!fromTutorials && <Box display={"flex"} flex={1} alignSelf={"stretch"} alignItems={"center"}>
                    <NewButton buttonText="Back" borderRadius={"20px !important"} padding="16px" extraSx={{
                        background: "var(--color-border)",
                        border: "none",
                        width: "102px",
                        height: "43px",
                        flex: 1,
                        marginBottom: "0px !important",
                        "&:hover": {
                            background: "var(--color-border)"
                        },
                        "&.MuiButton-outlined": {
                            border: `none`,
                        },
                        "&.MuiButton-contained": {
                            border: `none`,
                        },
                    }} fontSize={`16px`} fontWeight={600} typographySx={{
                        fontSize: "16px !important",
                        lineHeight: "16px !important",
                        fontWeight: `600 !important`,
                        letterSpacing: "2% important"
                    }} boxSx={{
                        padding: 0,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center"
                    }} onClick={closemodal} />
                </Box>}
                <Box display={"flex"} flex={1} alignSelf={"stretch"} alignItems={"center"}>
                    {isconnecting ? (
                        <NewButton
                            buttonText={
                                <Box display={"flex"} alignItems={"center"} justifyContent={"center"} gap={"8px"}>
                                    <ConnectingIcon />
                                    <CommonTypo>{isEditMode ? "Updating..." : "Connecting..."}</CommonTypo>
                                </Box>
                            }
                            onClick={() => { }}
                            extraSx={{
                                background: "var(--color-border)",
                                border: "none",
                                width: "102px",
                                height: "43px",
                                flex: 1,
                                marginBottom: "0px !important",
                                boxShadow: "none",
                                "&:hover": {
                                    background: "var(--color-border)",
                                    boxShadow: "none",
                                },
                                "&:after": {
                                    width: "48px"
                                },
                                "&.MuiButton-outlined": {
                                    border: `none`,
                                },
                                "&.MuiButton-contained": {
                                    border: `none`,
                                },
                            }}
                            boxSx={{
                                padding: 0,
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center"
                            }}
                        />
                    ) : (
                        <NewButton
                            buttonText="Connect"
                            onClick={connectToIntegration}
                            extraSx={{
                                background: "var(--color-new-main)",
                                border: "none",
                                width: "102px",
                                height: "43px",
                                flex: 1,
                                marginBottom: "0px !important",
                                "&:hover": {
                                    background: "var(--color-new-main)"
                                },
                                "&.MuiButton-outlined": {
                                    border: `none`,
                                },
                                "&.MuiButton-contained": {
                                    border: `none`,
                                },
                            }} fontSize={`16px`} fontWeight={600} typographySx={{
                                fontSize: "16px !important",
                                lineHeight: "16px !important",
                                fontWeight: `600 !important`,
                                letterSpacing: "2% important"
                            }}
                            isDisabled={!apiToken}
                        />
                    )}

                </Box>


            </Box>
        </Dialog>
        <SelectionDialogue
            isMobile={isMobile}
            modalType={modalType}
            openModal={openSelectionModal}
            onClose={() => {
                setEditMode(false)
                setOpenSelectionModal(false)
            }}
            fromTutorials={fromTutorials}
            rescueTimePercents={rescueTimePercents}
            tooglData={tooglData}
            updateRescueTime={updateRescueTime}
            updateToggl={updateToggl}
            updateOura={updateOura}
            updateGarmin={updateGarmin}
            updateWhoop={updateWhoop}
            updateGFit={updateGFit}
            rescueResponse={rescueResponse}
            togglResponse={togglResponse}
            ouraResponse={ouraResponse}
            garminResponse={garminResponse}
            garminData={garminData}
            whoopResponse={whoopResponse}
            gFitResponse={gFitResponse}
            ouraData={ouraData}
            whoopData={whoopData}
            gFitData={gFitData}
            isEditMode={isEditMode}
            setEditMode={setEditMode}
            ouraDataConversions={ouraDataConversions}
            gFitDataConversions={gFitDataConversions}
            whoopDataConversions={whoopDataConversions}
        />
        <ConnectingDialogue
            openModal={openConnectingModal}
            onClose={() => {
                setOpenConnectingModal(false)
            }}
            isMobile={isMobile}
        />
        {/* <SuccessDialogue isEditMode={isEditMode} 
             isMobile={isMobile} modalType={modalType} openModal={openSuccessModal} onClose={() => {
            setOpenSuccessModal(false)
            setEditMode(false)
        }} setModalType={setModalType} /> */}
    </>
}

export default IntegrationDialogue